import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { SessionMemberService } from '@crowdctrl/shared';

export function readSessionRouteParams(route: ActivatedRouteSnapshot): {
  workspaceId: string | null;
  sessionId: string | null;
} {
  let cursor: ActivatedRouteSnapshot | null = route;
  while (cursor) {
    const workspaceId = cursor.paramMap.get('id');
    const sessionId = cursor.paramMap.get('sessionId');
    if (workspaceId && sessionId) {
      return { workspaceId, sessionId };
    }
    cursor = cursor.parent;
  }
  return { workspaceId: null, sessionId: null };
}

export const joinedSessionGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const sessionMemberService = inject(SessionMemberService);
  const { workspaceId, sessionId } = readSessionRouteParams(route);

  if (!workspaceId || !sessionId) {
    return new RedirectCommand(router.createUrlTree(['/workspaces']), {
      replaceUrl: true,
    });
  }

  const joinCommands = ['/workspaces', workspaceId, 'sessions', sessionId, 'my-orders', 'join'];
  try {
    const membership = await firstValueFrom(
      sessionMemberService.getMySessionMember(sessionId, workspaceId, true),
    );
    if (membership?.joined) {
      return true;
    }
  } catch {
    // Redirect to join page on membership lookup failure to keep access bounded.
  }

  return new RedirectCommand(
    router.createUrlTree(joinCommands, {
      queryParams: { redirectUrl: state.url },
    }),
    { replaceUrl: true },
  );
};
